import {PaymentMethodBaseModel} from "../payment-method-base.model";
import {PaymentMethodCategoryEnum} from "../payment-method-category.enum";
import {ICardMethodViewModel} from "./card-method.view-model.interface";
import {PspCodesEnum} from "../psp-codes.enum";
import {Lazy} from "../../../../../../utils/lazy";
import {NuveiCardStrategy} from "./strategies/nuvei/nuvei-card.strategy";
import {ApcopayCardStrategy} from "./strategies/apcopay/apcopay-card.strategy";
import {RevolutCardStrategy} from "./strategies/revolut/revolut-card.strategy";
import {EmpCardStrategy} from "./strategies/emp/emp-card.strategy";
import {ICardStrategy} from "./strategies/card.strategy.interface";
import React from "react";
import {
    CardPaymentMethodsTabHeaderComponent
} from "../../../../../../pages/booking-flow/payment/card/card-payment-methods-tab-header.component";
import {Price} from "../../../../../currency/price";
import {
    StandardCardPayButtonComponent
} from "../../../../../../pages/booking-flow/payment/card/standard-card-pay-button.component";

export class CardMethodModel extends PaymentMethodBaseModel implements ICardMethodViewModel {

    get name(): string {
        return "Card";
    }

    get category(): PaymentMethodCategoryEnum {
        return PaymentMethodCategoryEnum.Card;
    }

    async canMakePayments(): Promise<boolean> {
        return true;
    }

    get amount(): Price {
        return this.booking.balanceDue;
    }

    private _nuveiStrategy: Lazy<NuveiCardStrategy> = new Lazy<NuveiCardStrategy>(() => {
        return new NuveiCardStrategy(this.booking);
    });

    private _apcopayStrategy: Lazy<ApcopayCardStrategy> = new Lazy<ApcopayCardStrategy>(() => {
        return new ApcopayCardStrategy(this.booking);
    });

    private _revolutStrategy: Lazy<RevolutCardStrategy> = new Lazy<RevolutCardStrategy>(() => {
        return new RevolutCardStrategy(this.booking);
    });

    private _empStrategy: Lazy<EmpCardStrategy> = new Lazy<EmpCardStrategy>(() => {
        return new EmpCardStrategy(this.booking);
    })


    get strategy(): ICardStrategy {
        return this._createStrategy()

    }

    private _createStrategy(): ICardStrategy {
        let strategy = this._getCardStrategy(this.pspCode)
            ?? this._getCardStrategy(this.services.configuration.data.payments.cardsFallbackPsp);
        if(strategy) {
            return strategy;
        } else {
            return this._nuveiStrategy.value;
        }

    }

    private _getCardStrategy(pspCode: PspCodesEnum): ICardStrategy | null {

        switch (pspCode) {
            case PspCodesEnum.Nuvei:
                return this._nuveiStrategy.value;
            case PspCodesEnum.Revolut:
                return this._revolutStrategy.value;
            case PspCodesEnum.Apcopay:
                return this._apcopayStrategy.value;
            case PspCodesEnum.EMP:
                return this._empStrategy.value;
            default:
                return null;

        }
    }

    async startPayment(): Promise<void> {
        await this.strategy.startPayment();
    }

    renderTabHeader(): React.ReactElement {
        return (
            <CardPaymentMethodsTabHeaderComponent/>
        );
    }

    renderTabContent(): React.ReactElement {
        return this.strategy.renderTabContent();
    }

    renderPayButton(): React.ReactElement {
        return (
            <StandardCardPayButtonComponent cardMethod={this}/>
        )
    }
}